import { SeparatorItem } from "../../interfaces/separator/Separator.type";

export default function Separator({ items }: { items: SeparatorItem[] }) {
  const lineType = items?.[0]?.lineType || "solid";
  const lineColor = items?.[0]?.lineColor || "red";

  return (
    <div
      className={`vas-p-0 vas-m-0`}
      style={{ borderBottom: `1px ${lineType} ${lineColor}` }}
    />
  );
}